<template>
	<div>
		<!-- Mandators -->
		<v-row>
			<v-col cols="12">
				<mandator-filter
					:appNameShort="appNameShort"
					:disable="false"
					@changeSelectedValue="(...args)=>this.emitSelectedValue('mandator',...args)"
					@mandatorError="(...args) => this.emitErrorEvent('mandator',...args)"
				/>
			</v-col>
		</v-row>
		<!-- Data pickers from - till interval -->
		<v-row>
			<v-col cols="12" md="6">
				<date-picker
					:label="txt.labels.dateFrom"
					:setDateTodayMinusOneDay="true"
					:disabled="disabled"
					@emitDate="(...args) => this.emitSelectedValue('fromDate',...args)"
				/>
			</v-col>
			<v-col cols="12" md="6">
				<date-picker
					:label="txt.labels.dateTill"
					:disabled="disabled"
					@emitDate="(...args) => this.emitSelectedValue('tillDate',...args)"
				/>
			</v-col>
		</v-row>
		<!-- Date picker multiple -->
		<v-row>
			<v-col cols="12" md="6">
				<date-picker-multiple
				:labelTextFiled="txt.labels.fromDatesMultiple"
				:disabled="disabled"
				:hint="hintForFromDatesMultiple"
				@emitDates="(...args) => this.emitSelectedValue('fromDates',...args)"
				/>
			</v-col>
			<v-col cols="12" md="6">
				<date-picker-multiple
				:labelTextFiled="txt.labels.tillDatesMultiple"
				:disabled="disabled"
				:hint="hintForTillDatesMultiple"
				@emitDates="(...args) => this.emitSelectedValue('tillDates',...args)"
				/>
			</v-col>
		</v-row>
		<!-- Serviceprovider -->
		<v-row>
			<v-col cols="12" md="6">
				<generic-autocomplete
					:api="api.serviceprovider.basePart"
					:queryProps="api.serviceprovider.props"
					:queryPropValues="[this.selectedMandatorId]"
					:label="txt.labels.serviceprovider"
					:triggerValue="selectedMandatorId"
					:preSelectAndHideIfOneItem="false"
					:selectAllOption="true"
					:groupingEffect="true"
					:disabled="disabled"
					@modelEmit="(...args) => this.emitSelectedValue('serviceproviders',...args)"
					@loading="(...args) => this.emitLoadingVariables('serviceproviders',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('serviceproviders',...args)"
				/>
			</v-col>
			<v-col cols="12" md="6">
				<generic-autocomplete
					:api="api.status.basePart"
					:queryProps="api.status.props"
					:queryPropValues="[this.selectedMandatorId]"
					:label="txt.labels.status"
					:triggerValue="this.selectedMandatorId"
					:preSelectAndHideIfOneItem="false"
					:selectAllOption="true"
					:groupingEffect="true"
					:disabled="disabled"
					@modelEmit="(...args) => this.emitSelectedValue('status',...args)"
					@loading="(...args) => this.emitLoadingVariables('status',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('status',...args)"
				/>
			</v-col>
		</v-row>
		<!-- nationality filter -->
		<v-row>
			<!-- country of residence -->
			<!-- <v-col cols="12" :md="this.selectedMandatorId == 7 && this.kantonVisible ? '6' : '12'"> -->
			<v-col cols="12" md="6">
				<generic-autocomplete
					:api="api.residenceCountry.basePart"
					:label="txt.labels.residenceCountry"
					:triggerValue="this.selectedMandatorId"
					:preSelectAndHideIfOneItem="false"
					:selectAllOption="true"
					:groupingEffect="true"
					itemText="name"
					:disabled="disabled"
					@modelEmit="(...args) => this.emitSelectedValue('residenceCountry',...args)"
					@loading="(...args) => this.emitLoadingVariables('residenceCountry',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('residenceCountry',...args)"
				/>
			</v-col>
			<v-col cols="12" md="6">
				<generic-autocomplete
					:api="api.isoNationality.basePart"
					:label="txt.labels.isoNationality"
					:triggerValue="this.selectedMandatorId"
					:preSelectAndHideIfOneItem="false"
					:selectAllOption="true"
					:groupingEffect="true"
					itemText="name"
					:show="showIso"
					:disabled="disabled"
					@modelEmit="(...args) => this.emitSelectedValue('isoNationality',...args)"
					@loading="(...args) => this.emitLoadingVariables('isoNationality',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('isoNationality',...args)"
				/>
			</v-col>
		</v-row>
		<v-row>
			<!-- kantons -->
			<v-col cols="12" md="6">
				<generic-autocomplete
					:api="api.kanton.basePart"
					:queryProps="api.kanton.props"
					:queryPropValues="this.api.kanton.props.map(el => el.value)"
					:label="txt.labels.kanton"
					:triggerValue="this.kantonFetchingTrigger"
					:preSelectAndHideIfOneItem="false"
					:selectAllOption="true"
					:groupingEffect="true"
					:show="kantonVisible"
					:disabled="disabled"
					@modelEmit="(...args) => this.emitSelectedValue('kanton',...args)"
					@loading="(...args) => this.emitLoadingVariables('kanton',...args)"
					@errorEmit="(...args) => this.emitErrorEvent('kanton',...args)"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import MandatorFilter from '../../arcCustom/filters/mandatorFilter.vue'
import GenericAutocomplete from '../../arcCustom/filters/GenericAutocomplete.vue'
import DatePicker from '../../arcCustom/DatePickerVue3.vue'
import DatePickerMultiple from '../../arcCustom/DatePickerMultiple.vue'

export default {
	name: 'RegistrationPrimaryFilter',
	components: {
		MandatorFilter,
		DatePicker,
		DatePickerMultiple,
		GenericAutocomplete,
	},
	props: {
		appNameShort: {
			type: String,
			required: true,
		},
		selectedMandatorId: {
			type: Number,
			required: true,
		},
		disabled: {
			type: Boolean,
			required: true,
		},
		selectedNationalitiesHesta: {
			type: Array,
		},
	},
	watch: {
		selectedMandatorId: {
			handler(value) {
				this.api.kanton.props = [{ name: 'country', value: 'CH' }, { name: 'mandator', value }]
			},
		},
	},
	data() {
		return {
			kantonVisible: false,
			kantonFetchingTrigger: 9999,
			selectedNationalitiesIso: [],
			selectedFromDates: [],
			selectedTillDates: [],
			api: {
				serviceprovider: {
					basePart: '/registration-report/form-serviceproviders',
					props: [{ name: 'installationid', value: 9999 }],
				},
				residenceCountry: {
					basePart: '/registration-report/iso',
				},
				kanton: {
					basePart: '/registration-report/kanton',
					props: [{ name: 'country', value: 'CH' }, { name: 'mandator', value: this.selectedMandatorId }],
				},
				status: {
					basePart: '/registration-report/form-status',
					props: [{ name: 'installationid', value: 9999 }],
				},
				isoNationality: {
					basePart: '/registration-report/iso',
					props: [{ name: 'installationid', value: 9999 }],
				},
			},
			txt: {
				labels: {
					serviceprovider: 'Serviceprovider',
					dateFrom: 'Date from - interval calculation',
					dateTill: 'Date till - interval calculation',
					fromDatesMultiple: 'Check-in dates of registration forms',
					tillDatesMultiple: 'Check-out dates of registration forms',
					residenceCountry: 'Country of residence',
					kanton: 'Canton',
					status: 'Status of registration from',
					isoNationality: 'Nationality as ISO',
				},
				hints: {
					fromDatesMultiple: `only registration forms having one of the seleted 
					dates as check-in date will be considered for the selected interval`,
					tillDatesMultiple: `only registration forms having one of the seleted 
					dates as check-out date will be considered for the selected interval`,
				},
			},
		}
	},
	computed: {
		showIso() {
			// eslint-disable-next-line max-len
			if (this.selectedNationalitiesIso.length == 0 && this.selectedNationalitiesHesta.length == 0) return true
			return !(this.selectedNationalitiesHesta.length > 0)
		},
		hintForFromDatesMultiple() {
			if (this.selectedFromDates.length > 0) return this.txt.hints.fromDatesMultiple
			return ''
		},
		hintForTillDatesMultiple() {
			if (this.selectedTillDates.length > 0) return this.txt.hints.tillDatesMultiple
			return ''
		},
	},
	methods: {
		emitSelectedValue(filterId, values) {
			const emittedObject = {
				filterId,
				values,
			}
			if (emittedObject.filterId == 'residenceCountry') this.triggerKantonFetching(values)
			if (emittedObject.filterId == 'isoNationality') this.handleIsoShowing(values)
			if (emittedObject.filterId == 'fromDates') this.handleHintForFromDatesMultiple(values)
			if (emittedObject.filterId == 'tillDates') this.handleHintForTillDatesMultiple(values)
			this.$emit('emitSelectedValue', emittedObject)
		},
		emitLoadingVariables(filterId, value) {
			const emittedObject = {
				filterId,
				value,
			}
			this.$emit('emitLoadingVariables', emittedObject)
		},
		emitErrorEvent(filterId, value) {
			const emittedObject = {
				filterId,
				value,
			}
			this.$emit('emitErrorEvent', emittedObject)
		},
		triggerKantonFetching(values) {
			/* Kantons should be fetched only for aletsch and only id Switzerland is selected as a country */
			const selectedCountryCodes = values.map((value) => value.alpha_2)
			if (this.selectedMandatorId == 7 && selectedCountryCodes.includes('CH')) {
				this.kantonVisible = true
				this.kantonFetchingTrigger += 1
			}
			if (!selectedCountryCodes.includes('CH')) this.kantonVisible = false
		},
		handleIsoShowing(value) {
			this.selectedNationalitiesIso = value
		},
		handleHintForFromDatesMultiple(values) {
			this.selectedFromDates = values
		},
		handleHintForTillDatesMultiple(values) {
			this.selectedTillDates = values
		},
	},
}
</script>

<style>

</style>
